import React from 'react';

let enabled = false;

class ScrollTop extends React.PureComponent {
  componentDidMount() {
    if (enabled) {
      window.scrollTo(0, 0);
    } else {
      enabled = true;
    }
  }

  render() {
    return null;
  }
}

export default ScrollTop;



// WEBPACK FOOTER //
// ../src/client/components/scroll/ScrollTop.js